/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable linebreak-style */
import React, { useState } from 'react';
import moment from 'moment';
import styled from '@emotion/styled';
import { motion, AnimatePresence, usePresence } from 'framer-motion';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';

import { addAdminReview, updateReview } from '../../network';

const Review = ({ comment, rating, time, likes, reviewID, firstName, setUpdateLike, customer, 
    customerID, userId, onClick = () => { }, activeLike, firstItem, setComment }) => {
    const useStyles = makeStyles((theme) => ({
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            borderRadius: '12px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(3, 3, 3),
        },
    }));

    const isPresent = usePresence();
    const animations = {
        initial: {border: '1px solid #D3D9DE'},
        animate: { border: '1px solid #ED8936'},
        // exit: { opacity: 0 }
        transition: { duration: 1 }
    };

    const reviewTime = moment(time).fromNow();
    const classes = useStyles();
    const [active, setActive] = useState(activeLike);
    const [modalStyle] = useState(getModalStyle);
    const [open, setOpen] = useState(false);
    const [editComment, setEditComment] = useState(comment);
    const [editRating, setEditRating] = useState(rating);
    const val = firstItem;
    // useEffect(() => {
    //     localStorage.setItem('activeLike', active);
    // }, [active]);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        setEditComment(e.target.value);
    };

    const updateLikes = () => {
        updateReview(reviewID, { likes: likes + 1 })
            .then(results => {
                setActive(true);
                setUpdateLike(likes + 1);
            })
            .catch(error => console.log(error));
    };

    const updateCustomerReview = () => {
        updateReview(reviewID, { comment: editComment, rating: editRating })
            .then(results => {
                console.log('test');
                setComment(Date.now());
                handleClose();
                addAdminReview({comment: results.comment, rating: results.rating, customer: results.customer, product: results.product, likes: results.likes})
                    .then(res => console.log(res)).catch(error => console.log(error));
            })
            .catch(error => console.log(error));
    };

    const body = (
        <ModalContainer style={modalStyle} className={classes.paper}>
            <p className="modal-title"> {firstName}, How would you rate this product? </p>
            <div>
                <Rating
                    name="customized-empty"
                    precision={0.5}
                    size="large"
                    emptyIcon={<StarBorderIcon fontSize="inherit" />}
                    onChange={(event, newValue) => {
                        setEditRating(newValue);
                    }}
                    value={editRating}
                />
            </div>

            <p className="modal-title"> Tell us about your experience using this product. </p>

            <ModalInput
                type="text"
                placeholder="This is where you write your review. Explain what happened. Keep
                your feedback honest, helpful, and constructive. Leave out any
                offensive words."
                value={editComment}
                onChange={handleChange}
            />

            <div className="button-container">
                <button
                    className={editComment?.length > 1 ? 'blue-done-btn' : 'done-btn'}
                    onClick={updateCustomerReview}
                >
                    Done </button>
                <button className="cancel-btn" onClick={handleClose}> Cancel</button>
            </div>

        </ModalContainer>
    );

    return (
        <ReviewWrapper onClick={onClick}>
            <ReviewContainer
                layout
                // eslint-disable-next-line react/jsx-props-no-spreading
                {... val && animations}
                initial={false}
            >
                <div className="section-spacing">
                    <div className="customer-rating">
                        <p className="reviewer-name"> {customer} </p>
                        <Box>
                            <Rating
                                name="customized-empty"
                                precision={0.5}
                                size="large"
                                emptyIcon={<StarBorderIcon fontSize="inherit" />}
                                readOnly
                                value={rating}
                            />
                        </Box>
                    </div>

                    <p className="review-time"> {reviewTime} </p>
                </div>

                <ReviewText>
                    {comment}
                </ReviewText>

                <div className="section-spacing">
                    <div className="like-section">
                        <svg
                            className={active ? 'likes-btn-active' : 'likes-btn'}
                            onClick={updateLikes}
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0)">
                                <path
                                    d="M11.6153 5.25001H7.85283V1.75001C7.88982 1.51174 7.87008 1.26811 7.79521 1.0389C7.72035 0.809694 7.59247 0.601378
                                7.42197 0.430878C7.25147 0.260378 7.04315 0.132501 6.81395 0.0576357C6.58474 -0.0172294 6.3411 -0.0369713 6.10283 1.37743e-05C5.98043
                                 0.00846177 5.86381 0.0552883 5.76956 0.133834C5.6753 0.212379 5.60822 0.318643 5.57783 0.437514L3.5 7.00001V14H11.0028C11.5592 13.9892 
                                 12.0936 13.7809 12.5104 13.4121C12.9272 13.0434 13.1993 12.5384 13.2778 11.9875L13.9778 7.96251C14.0329 7.63647 14.0144 7.30223 13.9235
                                  6.98428C13.8327 6.66634 13.6719 6.37274 13.4528 6.12501C13.2398 5.84184 12.9614 5.61439 12.6415 5.46203C12.3215 5.30967 11.9695 5.23693 
                                  11.6153 5.25001Z"
                                />
                                <path d="M2.33333 7H0V14H2.33333V7Z" />
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="14" height="14" />
                                </clipPath>
                            </defs>
                        </svg>

                        <p style={{ marginLeft: '0.5rem' }}> {likes} people liked this </p>
                    </div>

                    {customerID === userId ?
                        <img src="/customer-reviews/Edit.svg" alt="edit review" style={{ paddingRight: '0.5rem' }} onClick={handleOpen} /> : null
                    }

                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                    >
                        {body}
                    </Modal>
                </div>
            </ReviewContainer>
        </ReviewWrapper >
    );
};

export default Review;

const ReviewWrapper = styled.div``;

const ReviewContainer = styled(motion.div)`
    display: flex;
    flex-direction: column;
    gap: 20px;

    padding: 1rem;
    margin-bottom: 1rem;

    width: 29rem;
    height: fit-content;

    border: 1px solid #D3D9DE;
    border-radius: 8px;
    flex-wrap: wrap;

    @media only screen and (max-width: 500px){
        width: 90vw;
    }

    .section-spacing{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .customer-rating{
        display: flex;
        flex-direction: column;
    }

    .like-section{
        display: flex;
        flex-direction: row;
        align-items: center;

        color: #8D9AA5;
        font-size: 12px;
        padding-left: 0.5rem;
    }

    .reviewer-name{
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;

        display: flex;
        align-items: center;

        color: #000000;

        padding-left: 0.3rem;
    }

    .review-time{
        font-size: 10px;
        line-height: 10px;

        color: #000000;

        padding-right: 0.5rem;
    }

    .likes-btn{
        fill: #B3BDC6;
        &:hover{
        fill: #D69E2E;
    }
    }

    .likes-btn-active{
        fill: #D69E2E;
    }

    &:hover{
        box-shadow: 0px 8px 20px 0px #AAAAAA2E;
        cursor: pointer;
    }
`;

const ReviewText = styled.p`
    font-style: italic;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #000000;
    padding-left: 0.5rem;
`;

const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    padding: 5rem;

    width: 20rem;

    @media only screen and (max-width: 500px){
        width: inherit;
    }

    .modal-title{
        font-weight: normal;
        font-size: 16px;
        line-height: 16px;

        color: #000000;
    }

    .button-container{
        display: flex;
        justify-content: space-between;
    }

    .done-btn{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 12px;

        background: #D3D9DE;

        border-radius: 6px;
        width: 65px;
        height: 32px;

        color: #ffff;

        font-size: 16px;
        line-height: 16px;
    }

    .cancel-btn{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 12px;

        width: 77px;;
        height: 32px;

        border: 1px solid #525B64;
        box-sizing: border-box;
        border-radius: 6px;
        border: 1px solid #525B64;

        font-weight: 500;
        font-size: 16px;
        line-height: 16px;

        text-align: center;

        color: #525B64;
    }

    .blue-done-btn{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 12px;

        background: #049CBE;

        border-radius: 6px;
        width: 65px;
        height: 32px;

        color: #ffff;

        font-size: 16px;
        line-height: 16px;
    }
`;

const ModalInput = styled.input`
    background: #F6F8F8;
    padding: 16px 16px;

    border: 1px solid #D3D9DE;
    border-radius: 8px;

    height: fit-content;

    font-weight: normal;
    font-size: 12px;
    line-height: 12px;

    &::placeholder{
    color: #8D9AA5;
    }
`;

function getModalStyle() {
    const top = 40;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}
